import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import UpperNavBar from 'components/board/UpperNavBar';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Background } from './Background';


const PageNotFoundScreen = () => {

    useEffect(() => {
        Sentry.captureMessage('User tried to access unexisting url', 'warning');
    }, []);

    return (
        <div id="background-blue">
            <div className='grid-viewport'>
                <UpperNavBar />
            </div>

            <div id="screen-page-not-found" className="panel radius-rectangle full-width-form">
                <div className="panel-header">
                    <h3 className="bold-title center">
                        <span className="myparkd">MyParkd</span>
                    </h3>
                </div>
                <div className="panel-content">
                    <p className="center">
                        <FormattedMessage id="PAGE_404_MESSAGE" />
                    </p>
                    <Link to="/" className="btn-blue full-width">
                        <FormattedMessage id="PAGE_404_BTN_RETURN_HOME" />
                    </Link>
                </div>
            </div>
        </div>
    );

}

export default PageNotFoundScreen;